import { render, staticRenderFns } from "./epidemicSet.vue?vue&type=template&id=70681458&scoped=true&"
import script from "./epidemicSet.vue?vue&type=script&lang=js&"
export * from "./epidemicSet.vue?vue&type=script&lang=js&"
import style0 from "./epidemicSet.vue?vue&type=style&index=0&id=70681458&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70681458",
  null
  
)

export default component.exports